class Access_Numbers {
	constructor(options) {
		this.state_select = document.getElementById('state');
		this.country_select = document.getElementById('country');
		this.add_event_listeners();

		if (options && options.scroll_to_an) {
			$('html, body').animate({scrollTop: $(this.country_select).offset().top - 136}, 300);
		}
	}

	add_event_listeners() {
		this.country_select.addEventListener('change', () => {
			if (this.state_select) this.state_select.remove();
			document.forms.local_access_number.submit();
		});

		if (this.state_select) {
			this.state_select.addEventListener('change', () => {
				document.forms.local_access_number.submit();
			});
		}

		document.querySelectorAll('.tel-numbers-list a').forEach( (link) => {
			link.addEventListener('click', (event) => {
				event.stopImmediatePropagation();
			});
		});
	}
}
